
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import HeroSection from "@/components/home/HeroSection";
import LodgifySearchBar from "@/components/LodgifySearchBar";
import IntroductionSection from "@/components/home/IntroductionSection";
import AudienceSection from "@/components/home/AudienceSection";
import FeaturesSection from "@/components/home/FeaturesSection";
import TestimonialsSection from "@/components/home/TestimonialsSection";
import CTASection from "@/components/home/CTASection";
import { useMetaTags } from "@/hooks/useMetaTags";

const Index = () => {
  useMetaTags({
    title: "Flowerpot Cottage Tasmania | Luxury 4BR Accommodation for Families & Creative Retreats",
    description: "Spacious 4-bedroom cottage in Flowerpot, Tasmania. Perfect for multi-generational families, artists, writers & executives. Sleeps 8. Book your peaceful retreat.",
    canonicalPath: "/",
    keywords: "Flowerpot Tasmania accommodation, family holiday house Tasmania, artist retreat Tasmania, writer's retreat Tasmania, executive retreat Tasmania, multi-generational family accommodation, sleeps 8, musician retreat Tasmania, creative retreat Southern Tasmania, holiday house near Bruny Island, Tasmania accommodation from Melbourne, Huon Valley accommodation",
  });
  
  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />

      <main className="flex-grow">
        <HeroSection />
        <section className="py-4 px-6">
          <div className="max-w-4xl mx-auto">
            <LodgifySearchBar />
          </div>
        </section>
        <IntroductionSection />
        <AudienceSection />
        <FeaturesSection />
        <TestimonialsSection />
        <CTASection />
      </main>

      <Footer />
    </div>
  );
};

export default Index;
